export type AccessRole = 'account_owner' | 'manager' | 'user';

export const ACCESS_ROLES: { id: AccessRole; name: string; description: string }[] = [
  {
    id: 'account_owner',
    name: 'Account Owner',
    description: 'Manages the whole organisation, including people, roles and settings. Always at the top unit.',
  },
  {
    id: 'manager',
    name: 'Manager',
    description: 'Sees and manages every record in the chosen unit and the units under it.',
  },
  { id: 'user', name: 'User', description: 'Creates records and works on the ones they own or collaborate on.' },
];
